import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

type RouteChangeCallback = (pathname: string) => void

const useRouteChange = (callback: RouteChangeCallback) => {
  const location = useLocation()
  let callbackCalledOnce = false

  useEffect(() => {
    if (!callbackCalledOnce && callback && typeof callback === 'function') {
      callback(location.pathname)
      callbackCalledOnce = true
      if (location.hash) {
        const element = document.getElementById(location.hash.replace('#', ''))
        setTimeout(() => {
          element?.scrollIntoView({ behavior: 'smooth' })
          const url = `${location.pathname}${location.search}`
          window.history.replaceState({ path: url }, '', url)
        }, 100)
      }
    }
  }, [location.pathname])
}

export default useRouteChange
